var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 19.036,
    viewBox: "0 0 20.5 19.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M21.972,9.964H15.241L13.2,3.86a.741.741,0,0,0-1.391,0l-2.045,6.1H2.982a.734.734,0,0,0-.732.732.538.538,0,0,0,.014.124.7.7,0,0,0,.307.517l5.532,3.9L5.979,21.409a.734.734,0,0,0,.252.824.708.708,0,0,0,.412.178.9.9,0,0,0,.458-.165L12.5,18.4l5.4,3.848a.857.857,0,0,0,.458.165.657.657,0,0,0,.407-.178.725.725,0,0,0,.252-.824l-2.123-6.173L22.379,11.3l.133-.114a.768.768,0,0,0,.238-.49A.775.775,0,0,0,21.972,9.964Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#f2ae03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating-star.d626d4ad44f134342fa5d0bfc6f23e57.svg";
export { ForwardRef as ReactComponent };